import styled from 'styled-components';

export const Content = styled.div`
	@media (max-width: 576px) {
		display: ${props => props.isResponsive ? 'none' : 'flex'};
	}
	width: responsiveWidth(80);
    height: responsiveHeight(50);
    font-size: responsiveFontSize(2);
`;

export const ContentMobile = styled.div`
	@media (min-width: 576px) {
		display: none;
	}
	width: responsiveWidth(80);
    height: responsiveHeight(50);
    font-size: responsiveFontSize(2);
`;
